export default "__VITE_ASSET__edf74291__"